if (!customElements.get('venue-directory')) {
  customElements.define('venue-directory', class extends HTMLElement {
    connectedCallback() {
      this.filters = this.querySelector('.venue-directory-filters');
      this.groups = Array.from(this.querySelectorAll('[data-venue-group]'));
      this.buttons = Array.from(this.querySelectorAll('[data-venue-filter]'));
      this.status = this.querySelector('.venue-directory-results');
      this.onClick = (event) => {
        const button = event.target.closest('[data-venue-filter]');
        if (!button) return;
        const filter = button.dataset.venueFilter;
        this.setFilter(filter);
        const hash = filter === 'all' ? '' : `#${filter}`;
        history.replaceState(null, '', `${location.pathname}${location.search}${hash}`);
      };
      this.onHashChange = () => this.setFilter(location.hash.slice(1));
      this.filters.addEventListener('click', this.onClick);
      window.addEventListener('hashchange', this.onHashChange);
      this.setFilter(location.hash.slice(1));
      this.filters.hidden = false;
      this.status.hidden = false;
    }

    setFilter(value) {
      const filter = ['restaurants', 'mercados'].includes(value) ? value : 'all';
      let count = 0;
      this.groups.forEach((group) => {
        group.hidden = filter !== 'all' && group.dataset.venueGroup !== filter;
        if (!group.hidden) count += group.querySelectorAll('.venue-card').length;
      });
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.venueFilter === filter)));
      this.status.textContent = this.status.dataset.resultLabel.replace('__count__', String(count));
    }

    disconnectedCallback() {
      this.filters?.removeEventListener('click', this.onClick);
      window.removeEventListener('hashchange', this.onHashChange);
    }
  });
}
